// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormRemitos_container__Mu7x0 {
  animation: FormRemitos_init__zZ9VH 1s;
  display: flex;
  justify-content: center;
  align-items: center;
}

/*---Title---*/
.FormRemitos_container__Mu7x0 .FormRemitos_titleContainer__4GEhz {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.FormRemitos_container__Mu7x0 .FormRemitos_titleContainer__4GEhz h4 {
  width: 95%;
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.FormRemitos_container__Mu7x0 .FormRemitos_titleContainer__4GEhz .FormRemitos_arrow__vWzQK {
  transition: 0.3s;
}

.FormRemitos_container__Mu7x0 .FormRemitos_titleContainer__4GEhz .FormRemitos_arrow__vWzQK:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.FormRemitos_container__Mu7x0 .FormRemitos_stepperContainer__0tw6h {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.FormRemitos_container__Mu7x0 .FormRemitos_stepperButtons__nxMxd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 100px;
}

.FormRemitos_container__Mu7x0 .FormRemitos_stepperButtons__nxMxd .FormRemitos_button__3CWfz {
  width: 15rem;
  height: 3rem;
}

.FormRemitos_container__Mu7x0 .FormRemitos_data__8\\+po\\+ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 50px;
}

@keyframes FormRemitos_init__zZ9VH {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 600px) {
  .FormRemitos_container__Mu7x0 .FormRemitos_stepperButtons__nxMxd .FormRemitos_button__3CWfz {
    width: 40%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/FormRemitos.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .stepperContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .stepperButtons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 100px;\n}\n\n.container .stepperButtons .button {\n  width: 15rem;\n  height: 3rem;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n  margin-bottom: 50px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .container .stepperButtons .button {\n    width: 40%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FormRemitos_container__Mu7x0`,
	"init": `FormRemitos_init__zZ9VH`,
	"titleContainer": `FormRemitos_titleContainer__4GEhz`,
	"arrow": `FormRemitos_arrow__vWzQK`,
	"stepperContainer": `FormRemitos_stepperContainer__0tw6h`,
	"stepperButtons": `FormRemitos_stepperButtons__nxMxd`,
	"button": `FormRemitos_button__3CWfz`,
	"data": `FormRemitos_data__8+po+`
};
export default ___CSS_LOADER_EXPORT___;
